@if(!item.navCap) {
<a
  class="cursor-pointer menuLink"
  href="#"
  (click)="onItemSelected(item, $event)"
  [class.activeMenu]="!item.children?.length && isItemActive(item)"
  [attr.aria-expanded]="item.children?.length ? menuOpen : null"
  [attr.aria-haspopup]="item.children?.length ? 'menu' : null"
>
  @if(item.iconName){
  <app-nav-icon-pair
    class="routeIcon"
    [class.sub-item-icon]="!!item.subItemIcon"
    [icon]="item.iconName"
    [active]="isItemActive(item)"
    iconClass="routeIcon"
  />
  }
  {{ item.displayName | translate }}
  @if(item.children && item.children.length) {
  <span class="down-icon flex ml-auto">
    <mat-icon> expand_more </mat-icon>
  </span>
  }
</a>
}
@if(item.children?.length) {
<div class="childBox" role="menu" [attr.aria-hidden]="!menuOpen">
  @for(child of item.children; track trackChild(child, $index)) {
  <app-horizontal-nav-item
    [item]="child"
    [openModuleId]="openModuleId"
    (openModuleIdChange)="openModuleIdChange.emit($event)"
    class="ddmenu"
  >
  </app-horizontal-nav-item>
  }
</div>
}
